/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Hastily1Inputs */

const id_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cepat`)
};

const ms_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cepat`)
};

const da_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hurtigt`)
};

const de_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eilig`)
};

const en_us2_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hastily`)
};

const es_es2_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rápidamente`)
};

const es_mx2_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rápido`)
};

const fil_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mabilisan`)
};

const fr_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapidement`)
};

const it_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocemente`)
};

const hu_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyorsan`)
};

const nl_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snel`)
};

const no_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raskt`)
};

const pl_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pośpiesznie`)
};

const pt_br2_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apressadamente`)
};

const pt_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapidamente`)
};

const ro_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grăbit`)
};

const fi_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nopeasti`)
};

const sv_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snabb`)
};

const vi_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhanh`)
};

const tr_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceleyle`)
};

const cs_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rychle`)
};

const bg_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бързо`)
};

const ru_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстро`)
};

const uk_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Швидко`)
};

const ar_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بسرعة`)
};

const hi_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जल्दी`)
};

const th_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เร็ว`)
};

const ja_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`急いで`)
};

const zh_cn2_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速通`)
};

const zh_hant1_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速通`)
};

const ko_offerdetail_overview_hastily1 = /** @type {(inputs: Offerdetail_Overview_Hastily1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서둘러`)
};

/**
* | output |
* | --- |
* | "Hastily" |
*
* @param {Offerdetail_Overview_Hastily1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_hastily1 = /** @type {((inputs?: Offerdetail_Overview_Hastily1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Hastily1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_hastily1(inputs)
	if (locale === "ms") return ms_offerdetail_overview_hastily1(inputs)
	if (locale === "da") return da_offerdetail_overview_hastily1(inputs)
	if (locale === "de") return de_offerdetail_overview_hastily1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_hastily1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_hastily1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_hastily1(inputs)
	if (locale === "fil") return fil_offerdetail_overview_hastily1(inputs)
	if (locale === "fr") return fr_offerdetail_overview_hastily1(inputs)
	if (locale === "it") return it_offerdetail_overview_hastily1(inputs)
	if (locale === "hu") return hu_offerdetail_overview_hastily1(inputs)
	if (locale === "nl") return nl_offerdetail_overview_hastily1(inputs)
	if (locale === "no") return no_offerdetail_overview_hastily1(inputs)
	if (locale === "pl") return pl_offerdetail_overview_hastily1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_hastily1(inputs)
	if (locale === "pt") return pt_offerdetail_overview_hastily1(inputs)
	if (locale === "ro") return ro_offerdetail_overview_hastily1(inputs)
	if (locale === "fi") return fi_offerdetail_overview_hastily1(inputs)
	if (locale === "sv") return sv_offerdetail_overview_hastily1(inputs)
	if (locale === "vi") return vi_offerdetail_overview_hastily1(inputs)
	if (locale === "tr") return tr_offerdetail_overview_hastily1(inputs)
	if (locale === "cs") return cs_offerdetail_overview_hastily1(inputs)
	if (locale === "bg") return bg_offerdetail_overview_hastily1(inputs)
	if (locale === "ru") return ru_offerdetail_overview_hastily1(inputs)
	if (locale === "uk") return uk_offerdetail_overview_hastily1(inputs)
	if (locale === "ar") return ar_offerdetail_overview_hastily1(inputs)
	if (locale === "hi") return hi_offerdetail_overview_hastily1(inputs)
	if (locale === "th") return th_offerdetail_overview_hastily1(inputs)
	if (locale === "ja") return ja_offerdetail_overview_hastily1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_hastily1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_hastily1(inputs)
	return ko_offerdetail_overview_hastily1(inputs)
});
export { offerdetail_overview_hastily1 as "offerDetail.overview.hastily" }